import { Realtime } from '~/services/firebase';

type OrderStatusRealtimeProps = {
  order_id: string;
  user_id: string;
};

export function orderStatusRealtime({
  order_id,
  user_id,
}: OrderStatusRealtimeProps): void {
  const orderStatus = {
    order_id,
    status: '0',
  };

  const ref = Realtime.ref(`orders/${user_id}`);
  const newNotificationRef = ref.push();
  newNotificationRef.set(orderStatus);
}
